const useCtaLink = (link) => {
  if (!link || link.length === 0) {
    return [null, null]
  }
  if (Array.from(link)[0] === '/') {
    return [null, link]
  }
  return [link, null]
}

export default useCtaLink
